import { useState, useEffect, useRef } from "react";

/* ─── PALETTE ─── */
const PINK = "#e4006d";
const BLUE = "#0057ff";
const BORDER = "#e0e0e0";

/* ─── HERO SLIDES ─── */
const SLIDES = [
  {
    name: "Google Pixel 10a",
    subLabel: "Pixel 10a",
    headline: "Google Pixel 10a",
    price: "From £14 a month",
    desc: "Plus, pair with our 10GB data plan for just £7 extra a month for the first 3 months, £14 a month thereafter.",
    note: "Data plan price may change during the 12-month minimum term.",
    bg: "linear-gradient(135deg,#ff4e00 0%,#c030a0 45%,#2040c8 100%)",
    phoneBg: "linear-gradient(145deg,#ff6030 0%,#b040b8 50%,#3050d0 100%)",
    img: "https://lh3.googleusercontent.com/mv-jvBFT3HNr1HkFmtEZLgAKY9bH-lmFvhVdkOj2hzGKTz07Kol5qR7Lj7bHBSPg9vUr_A=s1280",
    fallbackColor: "#5080e0",
  },
  {
    name: "iPhone 16",
    subLabel: "iPhone 16",
    headline: "iPhone 16",
    price: "From £27 a month",
    desc: "The latest iPhone with A18 chip and Camera Control. Available in stunning new colours.",
    note: "Data plan price may change during the 12-month minimum term.",
    bg: "linear-gradient(135deg,#1a1a2e 0%,#16213e 50%,#0f3460 100%)",
    phoneBg: "linear-gradient(145deg,#2a2a4a 0%,#1a3a6a 100%)",
    img: "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-black?wid=5120&hei=2880&fmt=p-jpg&qlt=80&.v=1723477579059",
    fallbackColor: "#2a3a6a",
  },
  {
    name: "Samsung Galaxy S25",
    subLabel: "Galaxy S25",
    headline: "Samsung Galaxy S25",
    price: "From £25 a month",
    desc: "Packed with Galaxy AI. The thinnest Galaxy S ever, now with a titanium frame.",
    note: "Data plan price may change during the 12-month minimum term.",
    bg: "linear-gradient(135deg,#1a1a1a 0%,#2a2040 50%,#1a1030 100%)",
    phoneBg: "linear-gradient(145deg,#1e1e30 0%,#2a2050 100%)",
    img: "https://images.samsung.com/is/image/samsung/p6pim/uk/2501/gallery/uk-galaxy-s25-s931-sm-s931bzadeub-thumb-540254128",
    fallbackColor: "#1a1a3a",
  },
  {
    name: "OnePlus 13",
    subLabel: "OnePlus 13",
    headline: "OnePlus 13",
    price: "From £22 a month",
    desc: "Hasselblad camera system, Snapdragon 8 Elite, and a massive 6000mAh battery.",
    note: "Data plan price may change during the 12-month minimum term.",
    bg: "linear-gradient(135deg,#8b1a1a 0%,#c03020 50%,#e04030 100%)",
    phoneBg: "linear-gradient(145deg,#701010 0%,#c02020 100%)",
    img: "https://image01.oneplus.net/ebp/202501/07/1-m00-52-04-rb8tbwz5m-eafr_daadkxjffyvq8643.png",
    fallbackColor: "#c02020",
  },
];

/* ─── PHONE DEALS ─── */
const PHONES = [
  {
    name: "iPhone Air",
    color: PINK,
    tagline: "Pair with 50GB for £10. Data plan price may change during the 12-month minimum term",
    price: "27",
    extra: "Get more storage from £4 extra a month",
    label: "iPhone Air",
    phoneBg: "linear-gradient(160deg,#c8ddf8 0%,#e0eeff 100%)",
    img: "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-black?wid=800&hei=800&fmt=p-jpg&qlt=80",
  },
  {
    name: "Samsung Galaxy A37 5G",
    color: "#9b30d0",
    tagline: "Pair with 50GB for £10. Data plan price may change during the 12-month minimum term",
    price: "15",
    label: "Galaxy A37",
    phoneBg: "linear-gradient(160deg,#c0a0e0 0%,#e8d8ff 100%)",
    img: "https://images.samsung.com/is/image/samsung/p6pim/uk/2404/gallery/uk-galaxy-a55-5g-a556-sm-a556bzkaeub-thumb-540084783",
  },
  {
    name: "Pixel 10 Pro XL",
    color: "#1a7a3a",
    tagline: "Pair with 50GB for £10. Data plan price may change during the 12-month minimum term",
    price: "30",
    label: "Pixel 10 Pro XL",
    phoneBg: "linear-gradient(160deg,#888 0%,#ccc 100%)",
    img: "https://lh3.googleusercontent.com/mv-jvBFT3HNr1HkFmtEZLgAKY9bH-lmFvhVdkOj2hzGKTz07Kol5qR7Lj7bHBSPg9vUr_A=s800",
  },
];

/* ─── WHY ITEMS ─── */
const WHY = [
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="14" stroke="#555" strokeWidth="1.5" fill="none"/>
        <path d="M10 16 Q16 8 22 16 Q16 24 10 16Z" fill="#555"/>
        <path d="M16 8 L16 5 M16 24 L16 27" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    title: "Roll Spare Data",
    desc: "Your spare data rolls over ready to use later or use on a range of rewards.",
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect x="4" y="10" width="10" height="14" rx="2" stroke="#555" strokeWidth="1.5" fill="none"/>
        <rect x="18" y="8" width="10" height="14" rx="2" stroke="#555" strokeWidth="1.5" fill="none"/>
        <path d="M14 17 L18 17" stroke="#555" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M16 14 L18 17 L16 20" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      </svg>
    ),
    title: "Mix Your Plan",
    desc: "We know things change. That's why you can change your data plan whenever you like.",
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <rect x="8" y="4" width="16" height="24" rx="3" stroke="#555" strokeWidth="1.5" fill="none"/>
        <rect x="12" y="7" width="8" height="5" rx="1" fill="#555"/>
        <rect x="11" y="15" width="10" height="1.5" rx="0.75" fill="#aaa"/>
        <rect x="11" y="18" width="10" height="1.5" rx="0.75" fill="#aaa"/>
        <rect x="11" y="21" width="6" height="1.5" rx="0.75" fill="#aaa"/>
      </svg>
    ),
    title: "Text-to-Switch",
    desc: "Simply text PAC to 65075 to get your switching code. We'll take care of the rest.",
  },
  {
    icon: (
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M8 6h4l2 5-2.5 1.5a14 14 0 0 0 8 8L21 18l5 2v4c0 1.1-.9 2-2 2C12 26 6 20 6 8c0-1.1.9-2 2-2z" stroke="#555" strokeWidth="1.5" fill="none" strokeLinejoin="round"/>
        <path d="M20 6a6 6 0 0 1 6 6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
        <path d="M20 9a3 3 0 0 1 3 3" stroke="#555" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      </svg>
    ),
    title: "24/7 Switch Support",
    desc: "24/7 switching service with real person support.",
  },
];

const FAQS = [
  "Why choose Sky Mobile?",
  "How do I join Sky Mobile?",
  "Can I switch to Sky Mobile?",
  "Can I upgrade my device on Sky Mobile?",
  "Will I be charged when I use my phone abroad?",
  "Do I need to adjust my spend cap if I want to roam?",
  "How can I avoid roaming charges?",
  "What is Fair Usage?",
  "What is an eSIM?",
  "Here's the legal bit",
];

/* ══════════════════════════════════════════════════════
   ROOT
══════════════════════════════════════════════════════ */


/* ══════════════════════════════════════════════════════
   SUB-NAV (second row of tabs)
══════════════════════════════════════════════════════ */
function SubNav() {
  const tabs = ["Sky Mobile","Deals","Phones","Manage","SIM","Tablets & Laptops","Brands","SIM activation","Accessories"];
  return (
    <div style={{ borderBottom: `1px solid ${BORDER}`, overflowX: "auto", whiteSpace: "nowrap", background: "#fff" }}>
      <div style={{ display: "inline-flex", padding: "0 16px", minWidth: "100%" }}>
        {tabs.map((t, i) => (
          <a key={t} href="#" className="subnav-tab" style={{
            display: "inline-block",
            padding: "11px 14px",
            fontSize: 13,
            fontWeight: i === 0 ? 700 : 400,
            color: "#1a1a1a",
            textDecoration: "none",
            borderBottom: i === 0 ? `3px solid ${PINK}` : "3px solid transparent",
            marginBottom: -1,
          }}>{t}</a>
        ))}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   HERO CAROUSEL
══════════════════════════════════════════════════════ */
const HeroCarousel = () => {
  const images = [
    "https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt63f6d53630e47d0b/69c3b90016a1f8799d1c6740/2026_Q1_March_w14_SkyMobile_iPhone17e_Homepage_Banner_Desktop.png",
    "https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/bltef709680c7f0ed61/69cce5210a6de15f19554e71/2026_Q1_March_w15_SkyMobile_Pixel10a_Homepage_Banner_Desktop.png",
    "https://static.skyassets.com/contentstack/assets/blt143e20b03d72047e/blt6045bdd81b0fd425/69cce52176dc80371b222842/2026_Q1_March_w15_SkyMobile_SamsungS26_Homepage_Banner_Desktop.png"
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full h-[50vh] md:h-[80vh] overflow-hidden">
      {/* LEFT SHADOW */}
      <div className="absolute left-0 top-0 h-full w-24 z-10 bg-gradient-to-r from-black/40 to-transparent" />

      {/* RIGHT SHADOW */}
      <div className="absolute right-0 top-0 h-full w-24 z-10 bg-gradient-to-l from-black/40 to-transparent" />

      {/* SLIDER */}
      <div
        className="flex h-full w-full transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="hero"
            className="w-full h-full object-cover flex-shrink-0"
          />
        ))}
      </div>
    </div>
  );
};


function PhoneImg({ src, fallbackColor, alt }) {
  const [err, setErr] = useState(false);
  return err
    ? <div style={{ width: 220, height: 200, background: fallbackColor, borderRadius: 16, marginBottom: 0 }} />
    : <img src={src} alt={alt} onError={() => setErr(true)}
        style={{ width: 230, height: 210, objectFit: "contain", display: "block",
          filter: "drop-shadow(0 8px 28px rgba(0,0,0,0.4))" }} />;
}

/* ══════════════════════════════════════════════════════
   SHOP CATEGORIES
══════════════════════════════════════════════════════ */
function ShopCategories() {
  const CATS = [
    {
      label: "Phones",
      img: "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-black?wid=400&hei=400&fmt=p-jpg&qlt=80",
      bg: "#1a1a1a",
    },
    {
      label: "SIM only",
      sky: true,
      bg: "#fff",
    },
    {
      label: "Tablets & Laptops",
      img: "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/ipad-air-select-wifi-spacegray-202203?wid=400&hei=400&fmt=jpeg&qlt=80",
      bg: "#0a2a6a",
    },
    {
      label: "Accessories",
      img: "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MQDY3?wid=400&hei=400&fmt=jpeg&qlt=80",
      bg: "#2a2020",
    },
  ];

  return (
    <section style={{
      background: "linear-gradient(130deg, #d4006a 0%, #e83030 35%, #f07020 70%, #f8a030 100%)",
      padding: "28px 20px 32px",
      position: "relative", overflow: "hidden",
    }}>
      {/* diagonal lines */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
        background: "repeating-linear-gradient(-55deg, rgba(255,255,255,0.04) 0px, rgba(255,255,255,0.04) 2px, transparent 2px, transparent 28px)",
        pointerEvents: "none",
      }} />
      <div style={{ position: "relative", zIndex: 1 }}>
        <h2 style={{ textAlign: "center", color: "#fff", fontWeight: 800, fontSize: 20, marginBottom: 20, lineHeight: 1.3 }}>
          Shop the latest plans and devices
        </h2>
        <div className="cat-grid" style={{ maxWidth: 960, margin: "0 auto" }}>
          {CATS.map(c => (
            <div key={c.label} style={{
              background: "#fff", borderRadius: 6, overflow: "hidden",
              display: "flex", flexDirection: "column",
            }}>
              {/* image box */}
              <div style={{
                height: 110, background: c.bg,
                display: "flex", alignItems: "center", justifyContent: "center",
                overflow: "hidden",
              }}>
                {c.sky
                  ? <SimOnlyBox />
                  : <CatImg src={c.img} alt={c.label} />
                }
              </div>
              <div style={{ padding: "10px 10px 12px" }}>
                <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 9, color: "#1a1a1a" }}>{c.label}</div>
                <button style={{
                  width: "100%", background: BLUE, color: "#fff",
                  border: "none", borderRadius: 3, padding: "9px 0",
                  fontSize: 13, fontWeight: 700, cursor: "pointer",
                }}>Shop now</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CatImg({ src, alt }) {
  const [err, setErr] = useState(false);
  if (err) return <div style={{ width: 80, height: 80, background: "rgba(255,255,255,0.1)", borderRadius: 8 }} />;
  return <img src={src} alt={alt} onError={() => setErr(true)}
    style={{ width: "100%", height: "100%", objectFit: "contain", padding: 8 }} />;
}

function SimOnlyBox() {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: 8 }}>
      {/* Sky oval */}
      <svg width="56" height="26" viewBox="0 0 56 26">
        <ellipse cx="28" cy="13" rx="27" ry="12.5" fill="#001035"/>
        <text x="28" y="17.5" textAnchor="middle" fontSize="14" fontWeight="bold" fill="white" fontFamily="Arial">sky</text>
      </svg>
      {/* Mini SIM */}
      <svg width="38" height="50" viewBox="0 0 38 50" fill="none">
        <rect x="1" y="1" width="36" height="48" rx="5" fill="#e8e4d8" stroke="#bbb" strokeWidth="1"/>
        <rect x="7" y="12" width="24" height="28" rx="3" fill="#d4c890" stroke="#bbb" strokeWidth="0.8"/>
        <rect x="9" y="14" width="10" height="8" rx="1.5" fill="#b8a060"/>
        <rect x="9" y="24" width="20" height="2.5" rx="1" fill="#b8a060"/>
        <rect x="9" y="28" width="20" height="2.5" rx="1" fill="#b8a060"/>
        <rect x="9" y="32" width="20" height="2.5" rx="1" fill="#b8a060"/>
        <polygon points="25,1 36,1 36,12" fill="#d8d4c8"/>
      </svg>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   PHONE DEALS
══════════════════════════════════════════════════════ */
function PhoneDeals() {
  const [mobileIdx, setMobileIdx] = useState(0);

  return (
    <section style={{ padding: "44px 20px 32px", background: "#fff" }}>
      <h2 style={{ textAlign: "center", fontSize: 22, fontWeight: 800, color: PINK, marginBottom: 6 }}>
        Mobile Phone Deals
      </h2>
      <p style={{ textAlign: "center", fontSize: 14, color: "#555", marginBottom: 28, lineHeight: 1.5 }}>
        Browse our awesome phones to find the right one for you.
      </p>

      {/* DESKTOP: 3 columns */}
      <div className="deal-grid-desktop" style={{ maxWidth: 960, margin: "0 auto" }}>
        {PHONES.map(p => <DealCard key={p.name} p={p} />)}
      </div>

      {/* MOBILE: one at a time */}
      <div className="deal-grid-mobile">
        <DealCard p={PHONES[mobileIdx]} />
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 14, marginTop: 14, fontSize: 13 }}>
          <button onClick={() => setMobileIdx(i => (i - 1 + PHONES.length) % PHONES.length)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#555" }}>‹</button>
          <span>{mobileIdx + 1} of {PHONES.length}</span>
          <button onClick={() => setMobileIdx(i => (i + 1) % PHONES.length)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#555" }}>›</button>
        </div>
      </div>

      <div style={{ textAlign: "center", marginTop: 22 }}>
        <a href="#" style={{
          display: "inline-block", border: `2px solid ${BLUE}`, color: BLUE,
          borderRadius: 4, padding: "10px 30px", fontSize: 14, fontWeight: 700, textDecoration: "none",
        }}>Browse Phone Deals</a>
      </div>
    </section>
  );
}

function DealCard({ p }) {
  const [imgErr, setImgErr] = useState(false);
  return (
    <div style={{
      border: `1px solid ${BORDER}`, borderRadius: 6, overflow: "hidden",
      display: "flex", flexDirection: "column", background: "#fff",
    }}>
      {/* top text */}
      <div style={{ padding: "18px 16px 4px" }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: p.color, marginBottom: 8 }}>{p.name}</div>
        <div style={{ fontSize: 12, color: "#666", lineHeight: 1.5, marginBottom: 12 }}>{p.tagline}</div>
        <div style={{ fontSize: 12, color: "#555", marginBottom: 2 }}>from</div>
        <div style={{ display: "flex", alignItems: "flex-start", lineHeight: 1 }}>
          <span style={{ fontSize: 20, fontWeight: 900, marginTop: 4 }}>£</span>
          <span style={{ fontSize: 48, fontWeight: 900, lineHeight: 1 }}>{p.price}</span>
        </div>
        <div style={{ fontSize: 13, color: "#555", marginBottom: p.extra ? 12 : 0 }}>a month</div>
        {p.extra && (
          <div style={{
            border: "1.5px solid #1a1a1a", borderRadius: 4,
            padding: "8px 10px", fontSize: 12, fontWeight: 700,
            color: "#1a1a1a", lineHeight: 1.4, marginBottom: 4,
          }}>{p.extra}</div>
        )}
      </div>

      {/* phone image */}
      <div style={{
        background: p.phoneBg, flex: 1, minHeight: 190,
        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-end",
      }}>
        {imgErr
          ? <div style={{ width: 100, height: 170, background: "rgba(255,255,255,0.15)", borderRadius: 12, marginBottom: 0 }} />
          : <img src={p.img} alt={p.label} onError={() => setImgErr(true)}
              style={{ height: 175, objectFit: "contain", filter: "drop-shadow(0 4px 14px rgba(0,0,0,0.28))" }} />
        }
        <div style={{ fontSize: 11, color: "#555", padding: "6px 0 8px", background: "rgba(255,255,255,0.0)" }}>
          {p.label}
        </div>
      </div>

      {/* CTA */}
      <div style={{ padding: "12px 16px" }}>
        <button style={{
          width: "100%", background: BLUE, color: "#fff",
          border: "none", borderRadius: 3, padding: "11px",
          fontSize: 14, fontWeight: 700, cursor: "pointer",
        }}>View deal</button>
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   SIM ONLY BANNER
══════════════════════════════════════════════════════ */
function SimBanner() {
  return (
    <section style={{
      background: "linear-gradient(130deg, #c8006a 0%, #e02828 40%, #e86020 75%, #f09030 100%)",
      display: "flex", alignItems: "center", overflow: "hidden", position: "relative", height: 400,
    }} className="mx-48">
      {/* text */}
      <div style={{ flex: 1, padding: "36px 65px", zIndex: 2 }}>
        <h2 style={{ fontSize: 26, fontWeight: 800, color: "#fff", marginBottom: 10 }}>SIM only deals</h2>
        <p style={{ fontSize: 14, color: "rgba(255,255,255,0.92)", lineHeight: 1.6, maxWidth: 340, marginBottom: 20 }}>
          Whether you need more or less data each month, with Sky Mobile you can change your plan to make sure it always suits your lifestyle.
        </p>
        <button style={{
          background: "transparent", border: "2px solid #fff",
          color: "#fff", borderRadius: 4, padding: "10px 20px",
          fontSize: 13, fontWeight: 700, cursor: "pointer",
        }}>Browse SIM only deals</button>
      </div>
      {/* SIM card */}
      <div className="sim-card-wrap" style={{ padding: "28px 40px 28px 0", flexShrink: 0, zIndex: 2 }}>
        <BigSimCard />
      </div>
    </section>
  );
}

function BigSimCard() {
  return (
    <div style={{
      width: 130, height: 175, background: "linear-gradient(145deg,#e8e8e0 0%,#f8f8f4 100%)",
      borderRadius: 14, boxShadow: "0 10px 36px rgba(0,0,0,0.30)",
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", position: "relative", overflow: "hidden",
    }}>
      {/* cut corner top-right */}
      <div style={{
        position: "absolute", top: 0, right: 0, width: 0, height: 0,
        borderTop: "28px solid #d0d0c8", borderLeft: "28px solid transparent",
      }} />
      {/* sky logo */}
      <div style={{ position: "absolute", top: 10, left: 0, right: 0, textAlign: "center" }}>
        <svg width="44" height="20" viewBox="0 0 52 24">
          <ellipse cx="26" cy="12" rx="25" ry="11.5" fill="#001035"/>
          <text x="26" y="16.5" textAnchor="middle" fontSize="13" fontWeight="bold" fill="white" fontFamily="Arial">sky</text>
        </svg>
      </div>
      {/* gold chip */}
      <div style={{
        width: 70, height: 54, marginTop: 20,
        background: "linear-gradient(135deg,#c89820 0%,#f0d050 40%,#d4a828 100%)",
        borderRadius: 6, border: "1px solid #b08010",
        display: "grid", gridTemplateColumns: "1fr 1fr 1fr",
        gridTemplateRows: "1fr 1fr 1fr", gap: 2, padding: 5,
      }}>
        {[...Array(9)].map((_, i) => (
          <div key={i} style={{ background: "rgba(160,110,10,0.45)", borderRadius: 2 }} />
        ))}
      </div>
      {/* bottom lines */}
      <div style={{ marginTop: 10, width: 80 }}>
        {[...Array(3)].map((_, i) => (
          <div key={i} style={{ height: 3, background: "#c8c090", borderRadius: 2, marginBottom: 4 }} />
        ))}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   WHY SKY MOBILE
══════════════════════════════════════════════════════ */
function WhySkyMobile() {
  const [mobileIdx, setMobileIdx] = useState(0);
  return (
    <section style={{ padding: "44px 20px 36px", background: "#fff" }}>
      <h2 style={{ textAlign: "center", fontSize: 22, fontWeight: 800, color: PINK, marginBottom: 22 }}>
        Why Sky Mobile?
      </h2>

      {/* Desktop */}
      <div className="why-desktop" style={{ border: `1px solid ${BORDER}`, borderRadius: 6, maxWidth: 960, margin: "0 auto", display: "flex" }}>
        {WHY.map((w, i) => (
          <div key={w.title} style={{
            flex: "1 1 0", padding: "24px 18px", textAlign: "center",
            borderRight: i < WHY.length - 1 ? `1px solid ${BORDER}` : "none",
          }}>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>{w.icon}</div>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>{w.title}</div>
            <div style={{ fontSize: 12, color: "#666", lineHeight: 1.6 }}>{w.desc}</div>
          </div>
        ))}
      </div>

      {/* Mobile */}
      <div className="why-mobile">
        <div style={{ border: `1px solid ${BORDER}`, borderRadius: 6, padding: "24px 20px", textAlign: "center" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 12 }}>{WHY[mobileIdx].icon}</div>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 8 }}>{WHY[mobileIdx].title}</div>
          <div style={{ fontSize: 13, color: "#666", lineHeight: 1.6 }}>{WHY[mobileIdx].desc}</div>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 14, marginTop: 14, fontSize: 13 }}>
          <button onClick={() => setMobileIdx(i => (i - 1 + WHY.length) % WHY.length)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#555" }}>‹</button>
          <span>{mobileIdx + 1} of {WHY.length}</span>
          <button onClick={() => setMobileIdx(i => (i + 1) % WHY.length)}
            style={{ background: "none", border: "none", cursor: "pointer", fontSize: 18, color: "#555" }}>›</button>
        </div>
      </div>

      <div style={{ textAlign: "center", marginTop: 24 }}>
        <a href="#" style={{
          display: "inline-block", border: `2px solid ${BLUE}`, color: BLUE,
          borderRadius: 4, padding: "10px 28px", fontSize: 14, fontWeight: 700, textDecoration: "none",
        }}>See more about Sky Mobile</a>
      </div>
    </section>
  );
}

/* ══════════════════════════════════════════════════════
   FAQ
══════════════════════════════════════════════════════ */
function FaqSection() {
  const [open, setOpen] = useState(null);
  const [headOpen, setHeadOpen] = useState(true);
  return (
    <section style={{ padding: "0 20px 40px", maxWidth: 960, margin: "0 auto" }}>
      {/* FAQs header */}
      <button onClick={() => setHeadOpen(h => !h)} style={{
        width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
        background: "none", border: "none", borderTop: `1px solid ${BORDER}`,
        padding: "16px 0", cursor: "pointer", fontSize: 15, fontWeight: 700, color: "#1a1a1a",
      }}>
        FAQs
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ transform: headOpen ? "rotate(180deg)" : "none", transition: "transform .2s" }}>
          <path d="M3 6 L9 12 L15 6" stroke="#1a1a1a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {FAQS.map((q, i) => (
        <div key={i} style={{ borderTop: `1px solid ${BORDER}` }}>
          <button onClick={() => setOpen(open === i ? null : i)} style={{
            width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center",
            background: "none", border: "none", padding: "13px 0",
            cursor: "pointer", fontSize: 13, color: "#1a1a1a", textAlign: "left",
          }}>
            <span>{q}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, marginLeft: 12, transform: open === i ? "rotate(180deg)" : "none", transition: "transform .2s" }}>
              <path d="M3 6 L8 11 L13 6" stroke="#888" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          {open === i && (
            <div style={{ fontSize: 13, color: "#555", paddingBottom: 14, lineHeight: 1.7 }}>
              Answers to &ldquo;{q}&rdquo; will appear here.
            </div>
          )}
        </div>
      ))}
      <div style={{ borderTop: `1px solid ${BORDER}` }} />
    </section>
  );
}

/* ══════════════════════════════════════════════════════
   FOOTER
══════════════════════════════════════════════════════ */
function SkyFooter() {
  const links1 = ["Privacy options","Terms & conditions","Privacy & cookies notice","Accessibility","Site Map","Contact us","Complaints"];
  const links2 = ["Sky Group","Store locator"];
  return (
    <footer style={{ background: "#001035", color: "#aaa", padding: "24px 20px" }}>
      <div style={{ maxWidth: 960, margin: "0 auto" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 14, justifyContent: "center", marginBottom: 10 }}>
          {links1.map(l => <a key={l} href="#" style={{ color: "#aaa", fontSize: 12, textDecoration: "none" }}>{l}</a>)}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 14, justifyContent: "center", marginBottom: 18 }}>
          {links2.map(l => <a key={l} href="#" style={{ color: "#aaa", fontSize: 12, textDecoration: "none" }}>{l}</a>)}
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <svg width="44" height="20" viewBox="0 0 52 24">
              <ellipse cx="26" cy="12" rx="25" ry="11.5" fill="white"/>
              <text x="26" y="16.5" textAnchor="middle" fontSize="13" fontWeight="bold" fill="#001035" fontFamily="Arial">sky</text>
            </svg>
            <span style={{ fontSize: 11, color: "#666" }}>© 2026 Sky UK</span>
          </div>
          <span style={{ fontSize: 12, color: "#666" }}>Country: 🇬🇧</span>
        </div>
      </div>
    </footer>
  );
}

/* ══════════════════════════════════════════════════════
   SHARED STYLES
══════════════════════════════════════════════════════ */
const arrowStyle = {
  background: "rgba(255,255,255,0.88)",
  border: "none", borderRadius: "50%",
  width: 32, height: 32, display: "flex", alignItems: "center", justifyContent: "center",
  cursor: "pointer", fontSize: 18, fontWeight: 700,
  boxShadow: "0 2px 8px rgba(0,0,0,0.18)", color: "#333", lineHeight: 1,
};

const GLOBAL_CSS = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { margin: 0; }
  a { text-decoration: none; }

  /* ── Category grid ── */
  .cat-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
  }

  /* ── Phone deals ── */
  .deal-grid-desktop {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }
  .deal-grid-mobile { display: none; }

  /* ── Why section ── */
  .why-desktop { display: flex; }
  .why-mobile  { display: none; }

  /* ── Hero ── */
  .hero-phone-col { display: flex; }
  .hero-text-col  { display: flex; }
  .carousel-peek-left, .carousel-peek-right { display: flex; }
  .sim-card-wrap { display: block; }

  /* ════ MOBILE ════ */
  @media (max-width: 680px) {

    /* Hero: image full-width on top, text below */
    .hero-phone-col {
      width: 100% !important;
      height: 220px !important;
      justify-content: center;
    }
    .hero-text-col {
      padding: 16px !important;
    }

    /* Stack hero cols */
    .hero-phone-col ~ .hero-text-col {
      width: 100%;
    }

    /* Categories: 2x2 */
    .cat-grid {
      grid-template-columns: 1fr 1fr !important;
      gap: 10px !important;
    }

    /* Phone deals: hide desktop grid, show mobile carousel */
    .deal-grid-desktop { display: none !important; }
    .deal-grid-mobile  { display: block !important; }

    /* Why: hide desktop row, show mobile carousel */
    .why-desktop { display: none !important; }
    .why-mobile  { display: block !important; }

    /* SIM: hide SIM card image */
    .sim-card-wrap { display: none !important; }

    /* Carousel peeks */
    .carousel-peek-left, .carousel-peek-right { width: 40px !important; }
  }
`;

export default function Mobile() {
  return (
    <div style={{ fontFamily: "'Sky Text','Segoe UI',Arial,sans-serif", color: "#1a1a1a", background: "#fff" }}>
      <style>{GLOBAL_CSS}</style>
  
      <HeroCarousel />
      <ShopCategories />
      <PhoneDeals />
      <SimBanner />
      <WhySkyMobile />
      <FaqSection />
      <SkyFooter />
    </div>
  );
}